import classNames from 'classnames';
import React from 'react';

import styles from './Title.module.scss';

type TitleSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface Props {
    children?: React.ReactNode;
    size?: TitleSize;
    className?: string;
    text?: string;
}

export const Title: React.FC<Props> = ({ text, size = 'sm', className, children }) => {
    const mapTagBySize = {
        xxs: 'h6',
        xs: 'h5',
        sm: 'h4',
        md: 'h3',
        lg: 'h2',
        xl: 'h1',
    } as const;

    return React.createElement(
        mapTagBySize[size],
        { className: classNames(`${styles.heading} ${styles[mapTagBySize[size]]}`, className) },
        text,
        children
    );
};
